module.exports = __webpack_public_path__ + "static/media/DeleteIcon.7d170ab9.svg";